/**
 * CardSkeleton — Tailwind-only loading placeholder for lazy-loaded
 * result components. Shows a ta-card shell with animated pulsing
 * sections while the component chunk downloads.
 */

interface Props {
  title?: string;
  lines?: number;
  className?: string;
}

export function CardSkeleton({
  title,
  lines = 3,
  className = "",
}: Props) {
  return (
    <div className={`ta-card p-6 ${className}`}>
      {title && (
        <div className="text-xs uppercase tracking-wider text-slate-600 font-semibold mb-4">
          {title}
        </div>
      )}
      <div className="space-y-3 animate-pulse">
        {Array.from({ length: lines }).map((_, i) => (
          <div
            key={i}
            className="h-3 bg-slate-800/60 rounded"
            style={{
              width: `${60 + ((i * 17) % 35)}%`,
            }}
          />
        ))}
      </div>
    </div>
  );
}
